import { render, staticRenderFns } from "./DeliveryOrders.vue?vue&type=template&id=1f085aaa"
import script from "./DeliveryOrders.vue?vue&type=script&lang=js"
export * from "./DeliveryOrders.vue?vue&type=script&lang=js"
import style0 from "./DeliveryOrders.vue?vue&type=style&index=0&id=1f085aaa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports